import { send } from '../../../../../src/network/network';
import { type TagList } from '../../../../../src/types/TagList';

export async function getTag(tagId: number) {
  return send<TagList>({
    path: `/api/v2/tags/${tagId}/`,
    method: 'GET',
  });
}
